export default class EcosystemWheel {
  constructor(containerEl){
    this.container = document.querySelector(containerEl);
    this.contentAttribute = 'data-ecosystem-wheel-content';
    this.content = this.container.querySelectorAll(`[${this.contentAttribute}]`);
    this.defaultContent = this.container.querySelector('[data-ecosystem-wheel-content="default"]');
    this.slices = this.container.querySelectorAll('[data-ecosystem-wheel-el-type="slice"]');
    this.elementAttribute = 'data-ecosystem-wheel-el';
    this.activeClass = 'ecosystem-wheel__slice--active';
    this.inactiveOpacity = '0.15';

    // Check if there is a location hash and load that content if so, otherwise show default content
    if (window.location.hash) {
      this.showHashedContent();
    } else {
      this.showDefaultContent();
    }

    this.initEventListeners();
  }

  initEventListeners(){
    // Handle hovering and mouseleave of slice elements
    for (const el of this.slices) {
      el.addEventListener('mouseenter', (e) => {
        this.resetState();
        this.handleElementContent(e);
        this.setHash(e);
      });

      el.addEventListener('mouseleave', () => {
        this.resetState();
      });
    }
  }

  setHash(e) {
    window.location.hash = e.target.getAttribute(this.elementAttribute);
  }

  showHashedContent() {
    const contentSelector = window.location.hash.substring(1);
    const matchingContent = this.container.querySelector(`[${this.contentAttribute}=${contentSelector}]`);
    const matchingElement = this.container.querySelector(`[${this.elementAttribute}=${contentSelector}]`);

    matchingElement.classList.add(this.activeClass);
    this.showElementContent(matchingContent);
  }

  handleElementContent(e) {
    const contentSelector = e.target.getAttribute(this.elementAttribute);
    const matchingContent = this.container.querySelector(`[${this.contentAttribute}=${contentSelector}]`);

    this.hideAllContent();
    this.showElementContent(matchingContent);
  }

  showElementContent(el) {
    el.style.display = 'block';
  }

  resetState() {
    this.resetSlices();
    this.hideAllContent();
    this.showDefaultContent();
  }

  resetSlices() {
    for (const el of this.slices) {
      el.classList.remove(this.activeClass);
      el.style.opacity = '1';
    }
  }

  showDefaultContent() {
    this.showElementContent(this.defaultContent);
  }

  hideAllContent() {
    for (const el of this.content) {
      el.style.display = 'none';
    }
  }
}
